import Vue from 'vue';
import VueI18n, { Locale } from 'vue-i18n';
import { I18nOptions, LocaleMessages, WarnHtmlInMessageLevel } from 'vue-i18n/types';
import store, { RootState } from '@/store';
import { DataSettings } from '@/types';

Vue.use(VueI18n);

const messages: LocaleMessages = {
  en: require('@/i18n/lang/en.json'),
  fi: require('@/i18n/lang/fi.json'),
  se: require('@/i18n/lang/se.json'),
};

const warnHtmlInMessage: WarnHtmlInMessageLevel = 'off';

const browserLocale = navigator.language;

const options: I18nOptions = {
  locale: browserLocale,
  fallbackLocale: 'en',
  messages,
  warnHtmlInMessage,
  silentTranslationWarn: true,
  silentFallbackWarn: true
};

const i18n: VueI18n = new VueI18n(options);

function setI18nLanguageFromDataSettings(settings: DataSettings): void {
  const lang: Locale | undefined = settings && settings.lang;
  if (lang) {
    i18n.locale = lang;
  }
}

store.watch(
  (state: RootState) => state.dataManagement.settings,
  (settings: DataSettings) => {
    setI18nLanguageFromDataSettings(settings);
  }
);

export default i18n;
